'use strict';

var chunkV6YUYBTJ_js = require('./chunk-V6YUYBTJ.js');
var chunkWAUX3N2G_js = require('./chunk-WAUX3N2G.js');
var chunk32OAM7MJ_js = require('./chunk-32OAM7MJ.js');
var jsxRuntime = require('react/jsx-runtime');

var m=({linkToContent:l,linkText:e,onClick:s,className:o})=>{let a=o||"",d=e||"G\xE5 till huvudinneh\xE5ll";return jsxRuntime.jsx("div",{className:chunkWAUX3N2G_js.a(`${chunk32OAM7MJ_js.a}-hidden-link                  ${a}`),children:jsxRuntime.jsxs("a",{className:"link",href:l,onClick:s,children:[jsxRuntime.jsx(chunkV6YUYBTJ_js.b,{name:"arrow_forward",size:"sm",referenceSize:"link"}),jsxRuntime.jsx("span",{children:d})]})})},c=m;

exports.a = c;
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-UVSWQYMW.js.map